import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ToastService } from "./toast.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class PlanningService {
  private base_url = `${environment.API_URL}/planning`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);
  constructor(private http: HttpClient, private toast: ToastService) {}

  getPlanningDetail(planning_id) {
    return this.http
      .get(this.base_url + '/' + planning_id, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getPlanning(params) {
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  countAll(params) {
    
    return this.http
      .post(this.base_url+'/total', params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  countAllWithIncidents(params) {
    return this.http
    .post(this.base_url+'/total', params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  getMonthlyStats(params) {
    params = { month_date: params };
    return this.http
      .post(this.base_url + "/stats", params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createPlanning(params) {
    return this.http
      .post(this.base_url + "/create", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        this.toast.success(
          "Transport Ajouté au Planning avec succès.",
          false,
          "Planning"
        );
        return response;
        //window.location.reload();
      });
  }
  duplicatePlanning(planningId: number) {
    return this.http.post(`${this.base_url}/duplicate`, { id: planningId }, {
      headers:this.headers
    }).map((res) => {
      let response = JSON.parse(JSON.stringify(res));
      if (response) {
        this.toast.success("Transport dupliqué", false, "Planning");
      } else {
        this.toast.error(
          "Erreur lors de la copie du Transport.",
          false,
          "Planning"
        );
      }
      return response;
    })
  }

  updatePlanning(planning_id: number, params: object) {
    return this.http
      .patch(`${this.base_url}/${planning_id}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        console.log("response", response);
        if (response.id) {
          this.toast.success("Transport Mise à jour.", false, "Planning");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour du Transport.",
            false,
            "Planning"
          );
        }
        return response;
      });
  }

  deletePlanning(planning_id) {
    return this.http
      .delete(`${this.base_url}/${planning_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Transport Supprimée.", false, "Planning");
        } else {
          this.toast.error(
            "Erreur lors de la suppression du Transport.",
            false,
            "Planning"
          );
        }
      });
  }



  sendTransportMail(planning_id) {
    var params = {};
    params["planning_id"] = planning_id;
    return this.http
      .post(`${this.base_url}/${planning_id}/sendmails`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response == 200) {
          this.toast.success(
            "Email envoyé au Client et au Transporteur.",
            false,
            "Mail"
          );
        }
      });
  }
//envoi de mail à geofret qd le client fait une nouvelle demande de planning
  sendNewPlanningMail(planning_id) {
    var params = {};
    params["planning_id"] = planning_id;
    return this.http
      .post(`${this.base_url}/new/${planning_id}/sendmail`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response == 200) {
          this.toast.success(
            "Demande envoyée.",
            false,
            "Mail"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/planning.service.ts